export const TournamentAPI = {};

const SLICE = 'tournament';

TournamentAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/tournament`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TournamentAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/tournament`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TournamentAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/tournament`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TournamentAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/tournaments`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TournamentAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/tournament`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TournamentAPI.import = (file, onSuccess, onFailure) => {
  return {
    type: 'API',
    url: `/stream/tournaments/import`,
    method: 'POST',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    slice: SLICE,
    action: 'import',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};